import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,ToggleButton, ToggleButtonGroup,
  Paper,
  Divider,
  Grid,
  Chip,
  Tabs,
  Tab,
  LinearProgress,
} from "@mui/material";
import FaceIcon from "@mui/icons-material/Face";
import PlaceIcon from "@mui/icons-material/Place";
import ListAltIcon from "@mui/icons-material/ListAlt";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import DevicesOtherIcon from "@mui/icons-material/DevicesOther";
import { useEmployeeService } from "../../services/EmployeeService";
import FaceDataViewer from "./FaceDataViewer"; // Adjust import path
import DeviceLogList from "../Reports/DeviceLogList"; // Adjust import path
import EmployeeLocationList from "./EmployeeLocationList"; // Adjust import path
import EmployeeDetailedLog from "./EmployeeDetailedLog";
import AttendanceLogList from "./AttendanceLogList"; // Adjust import path
import EmployeeValidationSettings from "./EmployeeValidationSettings";
import ValidationLogList from "../Reports/ValidationLogList"; // Adjust import path

const EmployeeProfile = ({ empID = "GE00100947" }) => {
  const { fetchEmployees,updateFaceStatus } = useEmployeeService();
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tabIndex, setTabIndex] = useState(0);
  const [visitedTabs, setVisitedTabs] = useState([0]);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const allEmployees = await fetchEmployees(false);
        const found = allEmployees.find((e) => e.Group_Employee_Code === empID);
        setEmployee(found || null);
      } catch (err) {
        console.error("Failed to fetch employee profile:", err);
      } finally {
        setLoading(false);
      }
    };

    if (empID) load();
  }, [empID]);

  const handleTabChange = (event, newIndex) => {
    setTabIndex(newIndex);
    if (!visitedTabs.includes(newIndex)) {
      setVisitedTabs((prev) => [...prev, newIndex]);
    }
  };

    const handleApprove = async (item) => {
    try {
      const res = await updateFaceStatus({ faceGuid: item.faceGuid, status: "True" });
      console.log("Approved:", res);
      // Optionally refetch face data or show success message
    } catch (err) {
      console.error("Approval failed", err);
    }
  };
  
  const handleReject = async (allFaceData) => {
    try {
      const res = await updateFaceStatus({
        faceGuid: allFaceData[0].faceGuid, // or handle multiple if needed
        status: "Rejected",
      });
      console.log("Rejected:", res);
      // Optionally refetch face data or show success message
    } catch (err) {
      console.error("Rejection failed", err);
    }
  };
  

  

  if (loading) return <LinearProgress />;
  if (!employee)
    return (
      <Typography variant="body1" color="text.secondary" p={2}>
        No employee found for ID: {empID}
      </Typography>
    );

  return (
    <Box
      sx={{
        display: "block",
        width: "100%",
        minWidth: 0,
        overflowX: "hidden",
      }}
    >
      <Paper
        sx={{
          p: 1,
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          // backgroundColor: 'background.paper',
        }}
      >
        <Typography variant="h6" gutterBottom>
          Employee Profile
        </Typography>
        <Divider sx={{ mb: 1 }} />

        <Grid container spacing={2}>
          <Grid container spacing={2} size={9}>
            <Grid item size={{ xs: 6, sm: 4 }}>
              <Typography variant="body2" color="text.secondary">
                Employee Code
              </Typography>
              <Typography>{employee.Group_Employee_Code}</Typography>
            </Grid>
            <Grid item size={{ xs: 6, sm: 4 }}>
              <Typography variant="body2" color="text.secondary">
                Full Name
              </Typography>
              <Typography>{employee.Full_Name}</Typography>
            </Grid>

            <Grid item size={{ xs: 6, sm: 4 }}>
              <Typography variant="body2" color="text.secondary">
                Email
              </Typography>
              <Typography sx={{ wordBreak: "break-word" }}>
                {employee.Official_Email_ID}
              </Typography>
            </Grid>
            <Grid item size={{ xs: 6, sm: 4 }}>
              <Typography variant="body2" color="text.secondary">
                Mobile
              </Typography>
              <Typography>{employee.Mobile}</Typography>
            </Grid>

            <Grid item size={{ xs: 6, sm: 4 }}>
              <Typography variant="body2" color="text.secondary">
                HR Manager
              </Typography>
              <Typography>
                {employee.HR_Manager_Name} ({employee.HR_Manager_Code})
              </Typography>
            </Grid>
            <Grid item size={{ xs: 6, sm: 4 }}>
              <Typography variant="body2" color="text.secondary">
                Vertical
              </Typography>
              <Typography>{employee.Business_Vertical_Desc}</Typography>
            </Grid>

            <Grid item size={{ xs: 6, sm: 4 }}>
              <Typography variant="body2" color="text.secondary">
                Sub Vertical
              </Typography>
              <Typography>
                {employee.Business_Sub_Vertical_Description}
              </Typography>
            </Grid>
            <Grid item size={{ xs: 6, sm: 4 }}>
              <Typography variant="body2" color="text.secondary">
                Checked-in at-least Once
              </Typography>
              <Chip
                label={employee.CheckedInAtleastOnce === 1 ? "Yes" : "No"}
                color={
                  employee.CheckedInAtleastOnce === 1 ? "success" : "error"
                }
                size="small"
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} size={3} sx={{ borderLeft: "1px solid #e0e0e0" }}>
            <Grid item size={12} sx={{ px:1}} >
              <EmployeeValidationSettings empID={empID} />
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Box 
        sx={{
          mt: 0.2,        
          backgroundColor: "background.paper",
        minHeight: "58vh",
          overflowY: "auto",
        }}
      > 
   
       <Tabs
        value={tabIndex}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons
        allowScrollButtonsMobile
        TabIndicatorProps={{ style: { height: 2 } }}
      >
        <Tab icon={<FaceIcon />} label="Face Data" />
        <Tab icon={<PlaceIcon />} label="Assigned Locations" />
        <Tab icon={<ListAltIcon />} label="Activity Log" />
        <Tab icon={<CalendarMonthIcon />} label="Attendance Log" />
        <Tab icon={<FactCheckIcon />} label="Validation Requirements Log" />
        <Tab icon={<DevicesOtherIcon />} label="Device Log" />
      </Tabs>
    
      {/* <ToggleButtonGroup
        value={tabIndex}
        exclusive
        onChange={(e, value) => {
          if (value !== null) handleTabChange(value);
        }}
        fullWidth
        color="primary"
        sx={{
          "& .MuiToggleButton-root": {
            flexDirection: "column",
            py: 1.5,
            borderRadius: 4,
            textTransform: "none",
          },
        }}
      >
        <ToggleButton value={0}>
          <FaceIcon />
          Face Data
        </ToggleButton>
        <ToggleButton value={1}>
          <PlaceIcon />
          Assigned Locations
        </ToggleButton>
        <ToggleButton value={2}>
          <ListAltIcon />
          Activity Log
        </ToggleButton>
        <ToggleButton value={3}>
          <CalendarMonthIcon />
          Attendance Log
        </ToggleButton>
        <ToggleButton value={4}>
          <FactCheckIcon />
          Validation Requirements
        </ToggleButton>
        <ToggleButton value={5}>
          <DevicesOtherIcon />
          Device Log
        </ToggleButton>
      </ToggleButtonGroup> */}
    

        <Box sx={{ mt: 0, p: 1 }}>
          {visitedTabs.includes(0) && (
            <Box sx={{ display: tabIndex === 0 ? "block" : "none" }}>
             <FaceDataViewer empID={empID} onApprove={handleApprove} onReject={handleReject} />

            </Box>
          )}
          {visitedTabs.includes(1) && (
            <Box sx={{ display: tabIndex === 1 ? "block" : "none" }}>
              <EmployeeLocationList empID={empID} />
            </Box>
          )}
          {visitedTabs.includes(2) && (
            <Box sx={{ display: tabIndex === 2 ? "block" : "none" }}>
              <EmployeeDetailedLog empID={empID} />
            </Box>
          )}
          {visitedTabs.includes(3) && (
            <Box sx={{ display: tabIndex === 3 ? "block" : "none" }}>
              <AttendanceLogList empID={empID} />
            </Box>
          )}
           {visitedTabs.includes(4) && (
            <Box sx={{ display: tabIndex === 4 ? "block" : "none" }}>
              <ValidationLogList EmpID={empID} />
            </Box>
          )}
          {visitedTabs.includes(5) && (
            <Box sx={{ display: tabIndex === 5 ? "block" : "none" }}>
              <DeviceLogList empID={empID} />
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default EmployeeProfile;
